import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { take, tap } from 'rxjs';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import { BUTTON_TYPES } from 'src/app/components/shared/modal/components/modal-frame/modal-frame.constants';
import { SpecialCharacters } from 'src/app/core/enums';
import { LocationService } from 'src/app/core/services/admin/location/location.service';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { DISPLAY_TEXT } from '../add-group/add-group.constants';

@Component({
  selector: 'app-add-group',
  templateUrl: './add-group.component.html',
  styleUrls: ['./add-group.component.scss'],
  standalone: false,
})
export class AddGroupComponent implements OnInit {
  readonly CONSTANTS = DISPLAY_TEXT;
  readonly BUTTON_TYPES = BUTTON_TYPES;
  readonly REGEX = SpecialCharacters.ALPHABET_NUMBER;

  groupForm!: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<AddGroupComponent>,
    private fb: FormBuilder,
    private locationService: LocationService,
    private commonUtils: CommonUtils,
  ) {}

  ngOnInit(): void {
    this.groupForm = this.fb.group({
      ['groupCode']: [
        '',
        Validators.compose([Validators.required, Validators.maxLength(10)]),
      ],
      ['description']: [
        '',
        Validators.compose([Validators.required, Validators.maxLength(30)]),
      ],
    });
  }

  onReset() {
    this.groupForm.reset();
  }

  onSubmit() {
    const payload = {
      code: this.groupForm.get('groupCode')?.value,
      name: this.groupForm.get('description')?.value,
    };
    this.locationService
      .addLocationGroup(payload)
      .pipe(
        take(1),
        tap((response) => {
          if (response.code === 200) {
            this.commonUtils.updateBannerType(BANNER_TYPE.API_SUCCESS);
          }
          this.dialogRef.close(this.groupForm.value);
        }),
      )
      .subscribe();
  }

  onClose() {
    this.commonUtils.openExitModal(
      AddGroupComponent,
      null,
      this.groupForm.dirty,
    );
  }
}
